import { FormatColorHighlightIcon } from './FormatColorHighlightIcon';

/**
 * author: Austin Andrews
 * id 3681D567-0B40-47FF-843A-3258A16F935B
 * name format-color-highlight
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-color-highlight.svg
 * tags
 * - Color 
 * - Text / Content / Format 
 */
export const FormatColourHighlightIcon = FormatColorHighlightIcon;
export default FormatColourHighlightIcon